import { render, staticRenderFns } from "./AlignedSecuritiesBreakdownCard.vue?vue&type=template&id=2e9bca73&scoped=true&"
import script from "./AlignedSecuritiesBreakdownCard.vue?vue&type=script&lang=ts&"
export * from "./AlignedSecuritiesBreakdownCard.vue?vue&type=script&lang=ts&"
import style0 from "./AlignedSecuritiesBreakdownCard.vue?vue&type=style&index=0&id=2e9bca73&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e9bca73",
  null
  
)

export default component.exports